import { render, staticRenderFns } from "./CommonReportHeader.vue?vue&type=template&id=11671dcb&scoped=true"
import script from "./CommonReportHeader.vue?vue&type=script&lang=ts"
export * from "./CommonReportHeader.vue?vue&type=script&lang=ts"
import style0 from "./CommonReportHeader.vue?vue&type=style&index=0&id=11671dcb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11671dcb",
  null
  
)

export default component.exports